import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './config';
import * as serviceWorker from './serviceWorker';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import App from './routes/route';

import { BrowserRouter } from 'react-router-dom'

ReactDOM.render(
    <BrowserRouter>
        <Header></Header>
        <App />
        <Footer></Footer>
    </BrowserRouter>,
    document.querySelector('#root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
